export const getSubmitting = state => state.auth.submitting;

export const getAuth = state => state.auth.data || {};

export const getLoginStatus = state => state.auth.loginStatus;

export const getBookingDetail = state => state.booking.bookingDetail;

export const getAuthLoadingStatus = state => state.auth.loadingStatus;
